import React, { Component } from 'react'

class FeaturePlaceholder extends Component {
  render () {
    return (
      <div
        className={`product-options row border-color-ui-3  pt-2 pb-1  mx-0`}
      />
    )
  }
}

export default FeaturePlaceholder



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Feature/FeaturePlaceholder.js